import { useQuery } from '@tanstack/react-query';
import { graphQlClient } from '@config/graphqlClient';
import IncidentsGraphQL from '@graphql/incident.queries';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import { IncidentStatus } from '@models/incident.model';

export const INCIDENTS_BY_STATUS_QUERY_KEY = 'incidents-by-status';

export const useIncidentsByStatus = (status: IncidentStatus) => {
  const { organizationId } = useAppSelector(
    (state: RootState) => state.organization,
  );

  return useQuery({
    queryKey: [INCIDENTS_BY_STATUS_QUERY_KEY, organizationId, status],
    queryFn: async () => {
      if (!organizationId) return [];
      const data: any = await graphQlClient.request(
        IncidentsGraphQL.queries.getIncidentsByStatus,
        { organizationId, status },
      );
      return data.getIncidentsByStatus || [];
    },
    enabled: !!organizationId,
    staleTime: 30 * 1000, // Consider data fresh for 30 seconds
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
  });
};
